export default {


    postAddNewOfferTask: function(task) {
        return axios.post('/api/offer-task',
            task, {successHandle: true},
        );
    },
    postChangeOfferToProject: function(task) {
        return axios.post('/api/offer/changeOfferToProject',
            task, {successHandle: true},
        );
    },
    postUpdateOfferTask: function(response) {
        return axios.put('/api/offer-task/' + response.task.id,
            response.task, {successHandle: true},
        );
    },
    postDeleteOfferTask: function(response) {
        return axios.delete('/api/offer-task/' + response.task.id,
            response.task, {successHandle: true},
        );
    },
}
